import { ZfToggle } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { formatAmount } from '../../../utils/renderUtils';

interface IProps {
    title: string;
    totalText: string;
    currency?: string;
    totalAmountCurrentYear: number;
    showAll?: boolean;
    onShowAllClick?: (checked: boolean) => void;
    isBankable?: boolean;
}

export const BalanceSheetCategoryTitle: FunctionComponent<IProps> = ({
    title,
    totalText,
    currency,
    totalAmountCurrentYear,
    showAll,
    onShowAllClick,
    isBankable,
}) => {
    const { t } = useTranslation();

    const onShowAllToggle = (event: CustomEvent<boolean>) => onShowAllClick?.(event.detail);

    return (
        <div className="balance-sheet-category">
            <h4>{title}</h4>
            <div className="balance-sheet-category__total-text text-web-body-regular-lg">{totalText}</div>
            <h4 className="balance-sheet-category__amount-container">
                <span>{formatAmount(totalAmountCurrentYear, false, currency, isBankable)}</span>
                {onShowAllClick && <ZfToggle label={t('wealthShowAll')} checked={!!showAll} onToggleChange={onShowAllToggle} />}
            </h4>
        </div>
    );
};
